<template>
  <div>
    <div class="actionForm">
      <template v-for="conf in configs" v-if="conf.configId == $route.params.id">
        <h2 :set="confName = conf.name">Delete Configuration <span class="configName"> — {{ conf.name }}</span></h2>

        <div class="form">
          <ul>
            <li class="delete">
              <p class="formInfo">Are you sure you want to delete the configuration <span class="bold">{{ conf.name }}</span>? Keep in mind that this action will permanently delete your configuration.</p>
            </li>
            <li class="confirmation">
              <hr/>
              <p class="formInfo">Please type the exact name of the configuration to confirm.</p>
            </li>
            <li>
              <form @submit="deleteConfig(conf.configId)" @submit.prevent autocomplete="off">
                <label for="configName">Configuration Name  <span class="required">*</span></label>
                <input id="deleteName" v-model="deleteName" type="text" autocomplete="off" :placeholder="confName">
                <div class="warning" v-if="formSubmitted && (deleteName !== confName)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#FF2600" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M12.5,23.6c-6.1,0-11.1-5-11.1-11.1s5-11.1,11.1-11.1s11.1,5,11.1,11.1S18.6,23.6,12.5,23.6z"/><circle fill="#FF2600" cx="12.5" cy="18" r="1.5"/><path fill="#FF2600" d="M14,14c0,0.8-0.7,1.5-1.5,1.5S11,14.8,11,14V7c0-0.8,0.7-1.5,1.5-1.5S14,6.2,14,7V14z"/></svg>
                  <span>The configuration name does not match the name of the configuration requested to be deleted.</span>
                </div>
                <hr/>
                <input type="button" :disabled="deleteName != conf.name" @click="deleteConfig(conf.configId)" class="create btn confirm" value="Delete Configuration" title="Delete Configuration">
                <router-link :to="($route.params.hasOwnProperty('id')) ? '/manage/config/'+$route.params.id : '/manage'" class="discard btnOutline" title="Cancel">Cancel</router-link>
              </form>
            </li>
          </ul>
        </div>
      </template>  
    </div>
  </div>
</template>

<script>
  import store from '../store'
	import axios from 'axios'
  import VueAxios from 'vue-axios'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'

  export default {
    name: 'DeleteConfig',

    mixins: [mixin],

    data: function() {
      return {
        confName: '',
        deleteName: '',
        formSubmitted: false
      }
    },
    
    computed: {
        
      configs () {
          return store.state.configs
      },

    },

    methods: {
      deleteConfig(configId) {
        const vc = this;
        vc.formSubmitted = true;

        if(vc.deleteName == vc.confName) {
          axios
            .delete(process.env.VUE_APP_API_URL+'/configs/'+configId, {
                headers: {
                    'Authorization': 'Bearer '+store.state.authToken,
                }
              }
            )
            .then( function(response){
              vc.notify('<p>Configuration deleted successfuly.</p>', true)
              vc.fetchConfigs()
              router.push('/manage')
              $('.settingsMenu').removeClass('open')
              $('#app').removeClass('settings')
            }).catch(function(err) {
              vc.notify('<p>There was an error trying to delete your configuration.</p>', false, 'error')
              console.log(err);
            });
        }
      }
    }
  }
</script>


<style scoped>

</style>